// eslint-disable-next-line no-restricted-imports
import {
  flush as emotionFlush,
  hydrate as emotionHydrate,
  cx as emotionCx,
  merge as emotionMerge,
  getRegisteredStyles as emotionGetRegisteredStyles,
  css as emotionCss,
  injectGlobal as emotionInjectGlobal,
  keyframes as emotionKeyframes,
} from "@emotion/css";

import createEmotion from "@emotion/css/create-instance";

interface Emotion {
  flush: typeof emotionFlush;
  hydrate: typeof emotionHydrate;
  cx: typeof emotionCx;
  merge: typeof emotionMerge;
  getRegisteredStyles: typeof emotionGetRegisteredStyles;
  css: typeof emotionCss;
  injectGlobal: typeof emotionInjectGlobal;
  keyframes: typeof emotionKeyframes;
}

type CreateEmotion = (args: { key: string }) => Emotion;

/**
 * The typescript typings for CreateEmotion seem to be broken, so we
 * define it ourselves here.
 */
const patchedCreateEmotion = createEmotion as unknown as CreateEmotion;

/**
 * We create a new instance of emotion here so that we don't conflict with
 * the global emotion utilities from any other packages.
 */
export const { flush, hydrate, cx, merge, getRegisteredStyles, css, injectGlobal, keyframes } =
  patchedCreateEmotion({
    key: "mem-client",
  });
